export function disableAppScroll () {
  document.body.style.overflowY = `hidden`
}

export function enableAppScroll () {
  document.body.style.overflowY = `auto`
}

